import React from 'react';
import ReactMarkdown from 'react-markdown';
import './App.css';

function Message({ message }) {
  const messageClass = message.type === 'user' ? 'user-message' : 'bot-message';

  return (
    <div className={messageClass}>
      <div className="message-content">
        <ReactMarkdown>{message.content}</ReactMarkdown>
      </div>
    </div>
  );
}

export default Message;